<template>
    <div style="padding: 12px 0px">
        <div style="display: flex; justify-content: space-between;">
            <h2 style="font-weight: 600;">{{ $t('Generated Reports') }}</h2>
            <prozess-resource-name
                :to="{ name: 'reports-old.index' }"
                :title="$t('Switch to the old Reports Page')"
              />
        </div>
        <div class="widget-divv" style="display: flex; margin-top: 22px;">
            <div v-for="widgetInfo in widgets" :key="widgetInfo.name"
                style="padding: 12px 24px; min-width:120px; width: 100%; margin-left: 5px; margin-right: 5px;  border-radius: 4px;  background-color: white; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;">
                <p style="margin-bottom: 0px;"> {{ $t(widgetInfo.name) }}</p>
                <h1>{{ $t(widgetInfo.value) }}</h1>
            </div>
        </div>

        <div style="margin-left: 5px; margin-right: 5px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; border-radius: 8px; margin-top: 12px; background-color: white;">
            <div style="padding: 22px 24px; ">
                <div style="display: flex; justify-content: space-between;">
                    <h3> {{ $t('Reports List') }}</h3>
                    <button class="txt-btn" style="margin-top: 18px;" @click="clearFilters()">
                        <h5>{{ $t('Clear Filters') }}</h5>
                    </button>
                </div>
                <div style="display: flex;">
                   <div style="margin-right: 12px; width: 50%;">
                        <p style="margin-bottom: 0px; font-weight: 500;">{{ $t('Search Report') }}</p>
                        <prozess-input v-model="filters.reportSearch"
                            style="width: 100%; margin-top: 0px; padding-top: 0px;" />
                    </div>
                    <div style="margin-right: 12px; width: 50%;">
                        <p style="margin-bottom: 0px; font-weight: 500;">{{ $t('Report Module') }}</p>
                        <b-dropdown size="md" variant="outline-primary" style="width: 100%;">
                            <template #button-content>
                                <span class="text-nowrap">{{ $t(getReportModuleLabel(filters.moduleKey)) }}</span>
                            </template>
                            <b-dropdown-text style="width: 200px">{{ $t('Select Report Module') }}</b-dropdown-text>
                            <b-dropdown-item :key='allll'
                                @click="setReportModuleFilter('');">
                                {{ $t('All') }}
                            </b-dropdown-item>
                            <b-dropdown-item v-for="reportModule in modules" :key="reportModule.key"
                                @click="setReportModuleFilter(reportModule.key);">
                                {{ $t(reportModule.label) }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <!-- <div style="margin-right: 12px; width: 40%;">
                        <p style="margin-bottom: 0px; font-weight: 500;">{{ $t('Created by') }}</p>
                    </div> -->
                </div>
            </div>

            <div class="custom-tabl">
                <div style="padding: 12px 24px; border-top: solid 1px gainsboro; border-bottom: solid 1px gainsboro; background-color: rgb(249, 251, 252); display: flex;">
                    <h4 class="header-txt" style="width: 50%;">{{ $t('REPORT NAME') }}</h4>
                    <h4 class="header-txt" v-if="windowWidth>1000" style="width: 35%;">{{ $t('MODULE') }}</h4>
                    <!-- <h4 class="header-txt" v-if="windowWidth>1200" style="width: 30%;">{{ $t('CREATED BY') }}</h4> -->
                    <h4 class="header-txt" v-if="windowWidth>1420" style="width: 30%;">{{ $t('DATE CREATED') }}</h4>
                    <h4 class="header-txt" style="width: 40%;">{{ $t('ACTIONS') }}</h4>
                </div>
                    <div>
                        <div v-for="report in getReportItems()" :key="report.key" style="border-bottom: 1px gainsboro solid;  padding-left: 24px; padding-right: 24px;">
                            <div style="display: flex; padding-top: 6px; padding-bottom: 6px;">
                                <div class="col-block col-block-1" style="width: 50%;">
                                    <p class="row-txt" style="font-size: 1.1rem; font-weight: 600; margin-bottom: 0px;">{{ report.name }}</p>
                                    <p class="row-txt" style="font-size: 0.9rem; opacity: 0.8;">{{ report.subname }}</p>
                                </div>
                                <div v-if="windowWidth>1000" class="col-block col-block-2" style="width: 35%; overflow: hidden;">
                                    <p class="status-txt"
                                        v-if="report.module"
                                       :class="{
                                        'module-idd': report.module === 'idd'
                                        ,'module-sales': report.module === 'sales'
                                        }"
                                    >{{ $t(getReportModuleLabel(report.module)) }}</p>
                                </div>
                                <!-- <div v-if="windowWidth>1200" class="col-block col-block-3" style="width: 30%;">
                                    <p class="row-txt">{{ report.createdBy }}</p>
                                </div> -->
                                <div  v-if="windowWidth>1420" class="col-block col-block-4" style="width: 30%;">
                                    <p class="row-txt">{{ report.dateCreated }}</p>
                                </div>
                                <div class="col-block col-block-6" style="width: 40%;" :class="{ 'on-activity': generatinReport == report.id}">
                                    <button class="txt-btn" style="width: 100px;" @click="generateReport(report.id)">
                                        <h5 style="color:rgb(81, 173, 123); font-weight: 700; text-align: left;">{{ $t('Generate') }}</h5>
                                    </button>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="margin-left: 5px; margin-right: 5px;">
            <GeneratedReports/>
        </div>
    </div>
</template>
<script>
import reportQueryService from '@/services/reportQueries'
import reportService from '@/services/report'
import GeneratedReports from './GeneratedReports.vue'
import reportDashboardService from '@/services/reportDashboard'

export default {
    components: {
        GeneratedReports,
    },
    mounted() {
        this.getAllReports()
        this.getWidgets()
        this.$nextTick(() => {
        window.addEventListener('resize', this.onResize)
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            filters: this.getDefaultFilter(),
            widgets: [],
            // statuses: [
            //     { key: 'completed', label: 'Completed' },
                // { key: 'processing', label: 'Processing' },
            // ],
            modules: [
                { key: 'idd', label: 'IDD Compliance' },
                { key: 'sales', label: 'Sales' },
            ],
            reportItems: [],
            generatinReport: null,
        }
    },
     methods: {
        async getWidgets() {
            const widRes = await reportDashboardService.getWidgets()
            this.widgets = widRes.data
        },
        async getAllReports() {
            const repRes = await reportQueryService.getAll()
            const repItems = []
            repRes.data.forEach(rep => {
                repItems.push({
                    ...rep,
                    name: rep.label,
                    subname: rep.sublabel,
                    module: rep.moduleId,
                    // status: rep.statusId,
                })
            })
            this.reportItems = repItems
            // console.log('getAllReports', repItems)
        },
         onResize() {
            this.windowWidth = window.innerWidth
        },
        setReportModuleFilter(key) {
            this.filters.moduleKey = key
        },
        getReportModuleLabel(moduleKey) {
            if (moduleKey === '') {
                return 'All'
            }
            return this.modules.filter(m => m.key === moduleKey)[0]?.label
        },
        getStatusLabel(statusKey) {
            if (statusKey === '') {
                return 'All'
            }
            return this.statuses.filter(m => m.key === statusKey)[0]?.label
        },
        applyFilterClicked() {

        },
        getDefaultFilter() {
            return {
                moduleKey: '',
                status: '',
                reportSearch: '',
            }
        },
        clearFilters() {
            this.filters = JSON.parse(JSON.stringify(this.getDefaultFilter()))
        },
        getReportItems() {
            let reportss = JSON.parse(JSON.stringify(this.reportItems))
            if (this.filters.moduleKey) {
                reportss = reportss.filter(r => r.module === this.filters.moduleKey)
            }
            if (this.filters.status) {
                reportss = reportss.filter(r => r.status === this.filters.status)
            }
            if (this.filters.reportSearch !== '') {
                reportss = reportss.filter(r => r.name.toUpperCase().replace(' ', '').includes(this.filters.reportSearch.toUpperCase().replace(' ', '')))
            }
            return reportss
        },
       async generateReport(id) {
            this.generatinReport = id
            const genRes = await reportService.generateReport(id)
            this.generatinReport = null
        },
    },
}
</script>

<style lang="scss">
@import '@/assets/scss/company-contact-list.scss';
.header-txt{
    width: 100%;
    color: darkgray;
    opacity: 0.7;
    font-size: 1rem;
}
.txt-btn {
    width: 100px;
    cursor: pointer;
    transition: 0.2s;
    opacity: 0.7;
    margin-bottom: 0px;
    padding-left: 0px;
    border: none;
    background-color: transparent;
    outline: none;
    box-shadow: none;
}
.txt-btn:focus{
    outline: none;
    box-shadow: none;
}
.txt-btn:hover {
    opacity: 1;
}
.row-txt{
    margin-bottom: 0px;
}
.col-block {
    padding-top: 12px;
    padding-bottom: 12px;
}
.col-block-6{
    display: flex;
}
.status-txt{
    background-color: gainsboro;
    padding: 6px 24px;
    border-radius: 20px;
    text-align: center;
    width: fit-content;
}
.status-txt-2{
    background-color: gainsboro;
    padding: 0px 8px;
    border-radius: 20px;
    text-align: center;
    width: fit-content;
    font-size: 0.8rem;
    margin-bottom: 2px;
    margin-left: -4px;
}
.status-complete {
    background-color: rgb(219, 253, 234);
    color: rgb(22, 163, 75);
}
.status-processing {
    background-color: rgb(254, 249, 197);
    color:rgb(153, 127, 41);
}
.module-idd{
    background-color:rgb(224, 236, 255);
    color:rgb(32, 100, 241);
}
.module-sales{
    background-color: rgb(243, 232, 255);
    color:rgb(140, 51, 231);
}
.div-disabled{
    pointer-events: none;
    opacity: 0.3;
}
.on-activity{
    pointer-events: none;
    opacity: 0.7;
}
</style>
